module.exports = __webpack_public_path__ + "img/banner-2.31fbe1d3.png";